export const doesSectionSupportStreaming = section => {
  return 'type' in section && (section.type === 'LLM' || section.type === 'CONFIRMATION' || section.type === 'COLLABORATE');
};